import React, { Component } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import Modal from 'react-bootstrap/Modal';
import A11yFontIcon from 'components/A11yFontIcon';
import TextButton from 'components/TextButton';
import { padNumber } from 'utils/formatting';
import { GET_GAMES_QUERY } from 'utils/graphql/gamingQueries';
import { getLastGame } from 'utils/localStorage';
import { errorShape } from 'utils/shapes';
import CloseIcon from 'resources/Icon-Close-Btn.svg';
import SelectArrow from 'resources/select-arrow.svg';
import './ReportGameIssue.css';

const DESCRIPTION_LIMIT = 4000;
const ISSUE_TYPES = [
  'Frozen/Locked',
  'Game Kicks me out',
  'Score not updating',
  'Session Timeout',
  'Slow to load',
  "Won't Display Properly",
  "Won't load ",
  'Other'
];

class ReportGameIssue extends Component {
  constructor(props) {
    super(props);

    this.state = {
      issueGame: '',
      issueType: '',
      issueDescription: '',
      reportId: null,
      submitting: false,
      submitted: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formOpen && !this.props.formOpen) {
      this.resetForm();
    }
  }

  resetForm() {
    const curr = this.state;
    const newState = { submitted: false, issueGame: curr.issueGame };
    if (curr.reportId) {
      // Clear all input if this report was successfully submitted
      Object.assign(newState, {
        issueGame: '',
        issueType: '',
        issueDescription: '',
        reportId: null
      });
    }
    if ((!curr.issueDescription && !curr.issueType) || curr.reportId) {
      // Guess the game if the user hasn't modified the form
      const gameGuess = getLastGame();
      const games = this.props.games;
      if (!games || games.find(game => game.name === gameGuess)) {
        newState.issueGame = gameGuess;
      }
    }
    this.setState(newState);
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    const { submitted, submitting, issueDescription, issueType, issueGame } =
      this.state;
    let description = issueDescription.replace(/[\r]/g, '').trim();
    let gameName = issueGame.trim();

    if (
      !this.props.gamesLoading &&
      !submitted &&
      !submitting &&
      description &&
      description.length <= DESCRIPTION_LIMIT &&
      ISSUE_TYPES.indexOf(issueType) >= 0 &&
      gameName
    ) {
      this.props
        .addGameIssueReport({
          gameName: gameName,
          issueType: issueType,
          description: description
        })
        .then(resp => {
          this.setState({
            reportId:
              resp.data &&
              resp.data.addGameIssueReport &&
              resp.data.addGameIssueReport.id,
            submitting: false,
            submitted: true
          });
        })
        .catch(e => {
          this.setState({ reportId: null, submitting: false, submitted: true });
        });

      this.setState({ submitting: true });
    }

    event.preventDefault();
  }

  renderGameInput() {
    const { games, gamesLoading, gamesError } = this.props;

    if (gamesLoading) {
      return (
        <div className="select-loading">
          <A11yFontIcon icon="spinner" pulse fixed alt="" /> Loading...
        </div>
      );
    } else if (!gamesError && games && games.length) {
      return (
        <div class="select-wrapper">
          <select
            name="issueGame"
            value={this.state.issueGame}
            onChange={this.handleInputChange}
            required
          >
            <option value="" disabled hidden>
              &lt;Please choose...&gt;
            </option>
            {games.map(g => (
              <option value={g.name} key={g.name}>
                {g.displayName}
              </option>
            ))}
            <option value="other">Other</option>
          </select>
          <div class="custom-arrow">
            <img src={SelectArrow} alt="" />
          </div>
        </div>
      );
    } else {
      return (
        <input
          type="text"
          name="issueGame"
          value={this.state.issueGame}
          onChange={this.handleInputChange}
          required
        />
      );
    }
  }

  renderFormHeader() {
    return (
      <div className="form-header">
        Report Game Issue
        <button
          type="button"
          onClick={this.props.close}
          className="btn close-form-button"
          aria-label="Close Form"
        >
          —
        </button>
      </div>
    );
  }

  render() {
    const { supportOpen, formOpen, close } = this.props;
    const { issueDescription, issueType, submitting, submitted } = this.state;

    if (!supportOpen) {
      return null;
    } else if (!formOpen) {
      return null;
    } else if (!submitted && !submitting) {
      const charsLeft = DESCRIPTION_LIMIT - issueDescription.length;
      const limitClass = `input-limit ${charsLeft < 0 ? 'limit-exceeded' : ''}`;

      return (
        <Modal
          show={formOpen}
          onHide={this.props.close}
          className="modal-dialog-report-game-issue-modal"
          backdrop={'static'}
        >
          <Modal.Body>
            <h2 className="report-issue-title">Report Game Issue</h2>
            <div className="report-form">
              <div className="form-body">
                <label>What game is affected:</label>
                {this.renderGameInput()}
                <label>What type of issue are you seeing:</label>
                <div class="select-wrapper">
                  <select
                    name="issueType"
                    value={issueType}
                    onChange={this.handleInputChange}
                    required
                  >
                    <option value="" disabled hidden>
                      &lt;Please choose...&gt;
                    </option>
                    {ISSUE_TYPES.map(t => (
                      <option value={t} key={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  <div class="custom-arrow">
                    <img src={SelectArrow} alt="" />
                  </div>
                </div>

                <label>Please describe the issue: (*)</label>
                <textarea
                  name="issueDescription"
                  value={issueDescription}
                  onChange={this.handleInputChange}
                  required
                />
                <div className={limitClass}>
                  ({charsLeft} characters remaining)
                </div>
              </div>
              <div className="report-game-issue-submit">
                <button
                  onClick={this.handleSubmit}
                  type="button"
                  className="btn btn-success"
                  disabled={charsLeft < 0}
                >
                  Submit
                </button>
              </div>
            </div>
          </Modal.Body>
          <div className="dialog-close-button">
            <TextButton onClick={this.props.close} disabled={submitting}>
              <img src={CloseIcon} alt="Close Dialog" />
            </TextButton>
          </div>
        </Modal>
      );
    } else {
      return (
        <Modal
          show={formOpen}
          onHide={this.props.close}
          className="modal-dialog-report-game-issue-modal"
          backdrop={'static'}
        >
          <Modal.Body>
            <h2 className="report-issue-title">Report Game Issue</h2>
            <div className="report-form">{this.renderSubmittedBody()}</div>
          </Modal.Body>
          <div className="dialog-close-button">
            <TextButton onClick={close} disabled={submitting}>
              <img src={CloseIcon} alt="Close Dialog" />
            </TextButton>
          </div>
        </Modal>
      );
    }
  }

  renderSubmittedBody() {
    const { submitting, reportId } = this.state;
    if (submitting) {
      return (
        <div className="form-body submitted">
          <div className="header">
            <A11yFontIcon icon="spinner" pulse fixed alt="" /> Submitting...
          </div>
        </div>
      );
    } else if (reportId) {
      return (
        <div className="form-body submitted">
          <div className="header">Thank you for your report!</div>
          <div>
            We appreciate you taking the time to inform us of this issue! Your
            report will be forwarded to our staff for investigation.
          </div>
          <div>Your unique report ID is #{padNumber(reportId, 4)}.</div>
        </div>
      );
    } else {
      return (
        <div className="form-body submitted">
          <div className="header">
            There was a problem submitting your report
          </div>
          <div>
            We apologize for the inconvenience. Please try again later, or
            please contact us through the support chat.
          </div>
        </div>
      );
    }
  }
}

ReportGameIssue.propTypes = {
  supportOpen: PropTypes.bool,
  formOpen: PropTypes.bool,
  close: PropTypes.func,
  open: PropTypes.func,
  gamesLoading: PropTypes.bool,
  gamesError: errorShape,
  games: PropTypes.arrayOf(
    PropTypes.shape({
      displayName: PropTypes.string,
      name: PropTypes.string
    })
  )
};

const ADD_GAME_ISSUE_REPORT_MUTATION = gql`
  mutation MyAddGameIssueReport($input: AddGameIssueReport!) {
    addGameIssueReport(input: $input) {
      id
    }
  }
`;

export default compose(
  graphql(GET_GAMES_QUERY, {
    props: ({ ownProps, data }) => ({
      gamesLoading: data.loading,
      gamesError: data.error,
      games:
        !data.loading && data.games && data.games.games
          ? data.games.games
              .slice(0)
              .sort(({ displayName: a }, { displayName: b }) =>
                a.toLowerCase().localeCompare(b.toLowerCase())
              )
          : undefined
    })
  }),
  graphql(ADD_GAME_ISSUE_REPORT_MUTATION, {
    props: ({ ownProps, mutate }) => ({
      addGameIssueReport: input => mutate({ variables: { input: input } })
    })
  })
)(ReportGameIssue);
